import { ChevronRightIcon } from '@heroicons/react/24/outline';
import { useLocation, useNavigate } from 'react-router-dom';
import { useBreadcrumbs } from '../../hooks/useBreadcrumbs';
import { useTranslation } from '../../context/translationContext';

export interface BreadcrumbItem {
  path: string;
  name: string;
  hide?: boolean;
}

/**
 * Breadcrumbs navigation component
 */
export const Breadcrumbs = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { breadcrumbs } = useBreadcrumbs();
  const location = useLocation();

  return (
    <nav className="flex" aria-label="Breadcrumb">
      <ol className="inline-flex items-center space-x-1 md:space-x-3">
        {breadcrumbs.map((crumb: BreadcrumbItem, index: number) => {
          if (crumb.hide) return;
          return (
            <li key={index}>
              <div className="flex items-center">
                {index !== 0 && <ChevronRightIcon className="w-5 h-5 text-gray-400" />}
                <a
                  onClick={() => navigate(crumb.path)}
                  className={`ml-1 text-sm font-medium text-gray-400 hover:text-black md:ml-2 cursor-pointer ${
                    location.pathname === `/` + crumb.path ? `text-gray-800` : ``
                  }`}
                >
                  {t(crumb.name)}
                </a>
              </div>
            </li>
          );
        })}
      </ol>
    </nav>
  );
};
